// extracted by mini-css-extract-plugin
module.exports = {"user-details":"profile_user-details__1hMtd"};